import { useMemo } from 'react';

// import { replace } from '@change-corgi/core/i18n';
// import { useI18n } from '@change-corgi/core-react/i18n';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useSessionConfiguration } from 'src/app/shared/hooks/sessionConfiguration';

import type { BannerType, Copy, TosConfig } from './types';

export function useCopy(bannerType: BannerType | undefined, config: TosConfig): Copy {
	const {
		featureConfigs: { tosLegalNoticeBannerCopy },
	} = useSessionConfiguration();
	// TODO: re-implement localization logic to be compatible with SSR
	// currently not an issue because the copy FCM (tos_legal_notice_banner_copy) in production is not using those replacement values
	// const { localizeDate } = useI18n();
	const {
		errorReporter: { report },
	} = useUtilityContext();

	return useMemo(() => {
		if (!bannerType || !tosLegalNoticeBannerCopy || !config) {
			return { body: '' };
		}
		// const date = new Date(config.effectiveDate);
		try {
			return {
				body: tosLegalNoticeBannerCopy[bannerType === 'post' ? 'postEffectiveText' : 'preEffectiveText'],
				// replace(tosLegalNoticeBannerCopy[bannerType === 'post' ? 'postEffectiveText' : 'preEffectiveText'], {
				// tosEffectiveDateShort: localizeDate(date, 'date', 'short'),
				// tosEffectiveDateMedium: localizeDate(date, 'date', 'medium'),
				// tosEffectiveTime: localizeDate(date, 'time', 'short'),
				// }),
			};
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			void report({
				// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
				error: e,
				params: { location: 'tos banner' },
			});
			return { body: '' };
		}
	}, [bannerType, tosLegalNoticeBannerCopy, config, report]);
}
